import { render, staticRenderFns } from "./therapyBillingEditDlg.vue?vue&type=template&id=bec30dfc&"
import script from "./therapyBillingEditDlg.vue?vue&type=script&lang=js&"
export * from "./therapyBillingEditDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports